<template>
  <div id="app">
    <HeadBlock />
    <router-view />
    <FooterBlock />
  </div>
</template>

<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";

export default {
  name: "App",
  components: {
    HeadBlock,
    FooterBlock,
  },
};
</script>

<style></style>
